const parseErrorMessage = (message: string): string => {
  const noNodeInModelMessage = 'GraphQL error: No Node for the model';
  const alreadyUploadedMessage = 'GraphQL error: A unique constraint would be violated on ';
  const formatErrorMessage = 'GraphQL error: Format Error - ';
  const clientDefinedError = 'Client error - ';

  if (message && message.includes(noNodeInModelMessage)) {
    const summary = message.split('.')[0];

    return `No ${summary.split(noNodeInModelMessage)[1].trim()}. Please remove this record and re-upload`;
  }

  if (message && message.includes('Details: Field name = email')) {
    return 'This email is already in use';
  }

  if (message && message.includes(alreadyUploadedMessage)) {
    const table = message.split(alreadyUploadedMessage)[1].split('.')[0];

    return `${table} already exists!`;
  }

  if (message && message.includes(formatErrorMessage)) {
    return message.split(formatErrorMessage)[1];
  }

  if (message && message.includes(clientDefinedError)) {
    return message.split(clientDefinedError)[1];
  }

  return 'Something went wrong with the operation';
};

export { parseErrorMessage };
